import React from 'react'
import styles from './styles.module.css'
import PeopleName from './Name/PeopleName'
import PeopleTitle from './Title/PeopleTitle'
import PeopleDataSeen from './DataSeen/PeopleDataSeen'
import PeopleCheckbox from './PeopleCheckbox/PeopleCheckbox'
import CurrentOwnershipType from './CurrentOwnershipType/CurrentOwnershipType'

function People ({
  localPeopleData,
  setLocalPeopleData
  // localPeopleDateRange,
  // setLocalPeopleDateRange
}) {
  return (
    <div className={styles.peopleSection}>
      <div className={styles.titleWithIcon}>
        <h1 style={{ fontSize: '14px', fontWeight: '500' }}>
          People & Ownership
        </h1>
      </div>

      <div style={{ display: 'flex', gap: '16px' }}>
        <PeopleName
          localPeopleData={localPeopleData}
          setLocalPeopleData={setLocalPeopleData}
        />
        <PeopleTitle
          localPeopleData={localPeopleData}
          setLocalPeopleData={setLocalPeopleData}
        />
        <PeopleDataSeen
          localPeopleData={localPeopleData}
          setLocalPeopleData={setLocalPeopleData}
        />
        <PeopleCheckbox
          localPeopleData={localPeopleData}
          setLocalPeopleData={setLocalPeopleData}
        />
      </div>

      <div style={{ marginTop: '18px' }}>
        <CurrentOwnershipType
          localPeopleData={localPeopleData}
          setLocalPeopleData={setLocalPeopleData}
        />
      </div>
    </div>
  )
}

export default People
